import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun } from 'validations/rules';

const Validations = [ruleRunner('delivery_days', 'prazo de entrega', required, minimun(1))];

export default Validations;
